import { render, staticRenderFns } from "./PhotosGallery.vue?vue&type=template&id=4c30bf8a&scoped=true"
import script from "./PhotosGallery.vue?vue&type=script&lang=js"
export * from "./PhotosGallery.vue?vue&type=script&lang=js"
import style0 from "./PhotosGallery.vue?vue&type=style&index=0&id=4c30bf8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c30bf8a",
  null
  
)

export default component.exports